import React, { FC, useEffect, useState } from 'react';
import { ICountryBeneficiaries } from "@interfaces/screens/beneficiaries.interface";
import { DataGrid, Column, MasterDetail, Summary, TotalItem, CustomRule } from 'devextreme-react/data-grid';
import { Utilities, Enums, Constants, numeral } from "@utils";
import { CountryBeneficiariesPresenter } from '@presenters/screens/country-beneficiaries.presenter';
import CountryDetail from './country-detail';
import { Container, Alert } from "reactstrap";
import { Button } from "reactstrap";
import styles from './country-beneficiaries.module.scss'; 

const CountryBeneficiaries: FC<any> = () => {
  const [dataColumns, setDataColumns] = useState(null);
  const [dataSource, setDataSource] = useState([])
  const [duplicatesSP, setDuplicatesSP] = useState([])

  let view: ICountryBeneficiaries = {
    state:{
      dataColumns: dataColumns,
      dataSource: dataSource,
      duplicatesSP: duplicatesSP,
      setDataColumns:setDataColumns,
      setDataSource:setDataSource,
      setDuplicatesSP:setDuplicatesSP
    }
  };

  let presenter =  new CountryBeneficiariesPresenter(view);

  useEffect(() => {        
    presenter.initialize();
  }, []);

  useEffect(() => {        
    if(presenter.formMasters && presenter.BudgetsData) presenter.initReport();
  }, [presenter.formMasters, presenter.BudgetsData]);

  const renderCellTemplate = (
    container: any,
    options: any,
    column: any,
  ) => {
 
    let _value = options.value;
    const _format = column.format;
    switch (column.fieldType) {
      case Enums.FieldTypes.Number:
        {
          _value = `${numeral(options.value).format(
            _format ? _format : Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL
          )}`;
        }
        break;
    }
    container.textContent = _value;
  };

  const renderColumn = (column: any, pivot?: any, dataDetail?: any) => {
    const commonProps = {
      cellTemplate: (container: any, _props: any) =>
        renderCellTemplate(container, _props, column),
      dataField: column.dataField,
      caption: column.caption,
      width: column.width,
      allowEditing: !column.readOnly,
      alignment: column.alignment,
      calculateCellValue: column.calculateCellValue,
      visible: column.visible,
      groupIndex: column.groupIndex,
      sortOrder: column.sortOrder,
      fixed: column.fixed,
      fixedPosition: column.fixedPosition,
    };
    switch (column.fieldType) {
      default: {
        return (
          <Column
            {...commonProps}
            key={`country-${column.dataField}`}
            dataType={column.dataType}
          >
          {getDuplicateCalculation(column, pivot, dataDetail)}
          </Column>
        );
      }
    }
  };

  const renderDetail = (props:any) => {
    return (
      <CountryDetail
        presenter={presenter}
        renderColumn={renderColumn}
        data={props.data}
        duplicatesSP={duplicatesSP}
        pivotData={dataSource}
      ></CountryDetail>
    );
  }

  const calculateTotalRow = (options: any) => {
    if (options.summaryProcess === 'start' && options.name !== "notValue") {
      options.totalValue = 0;
    } else if (options.summaryProcess === 'calculate' && options.name !== "notValue") {
      let sumaData = 0;

      if(options.name.includes("Duplicate")){
        let newName = options.name.replace("Duplicate","")
        dataSource.forEach(data => { sumaData += (data[newName] || 0) });
        options.totalValue = sumaData
      }else{
        let sumaDup = 0;
        dataSource.forEach(data => { sumaData += (data[options.name] || 0) });
        duplicatesSP.forEach(dup => {  sumaDup += (dup[options.name] || 0) });
        options.totalValue = sumaData - sumaDup;
      }
    }
  }

  const getDuplicateCalculation = (column: any, pivot: any, dataDetail: any) => {
    return column.validateDuplicates ? (
      <CustomRule ignoreEmptyValue={true} validationCallback={(e: any) => presenter.validateCell(e, pivot, dataDetail)} message={column.validationErrorMessage}/>
    ) : (
      ''
    );
  };

  return (
    <>
      <h1 className={styles.SuperposicionTitle}>
        {`${presenter.currentLabels.get("SuperposicionTitle")} - ${presenter.country} - ${presenter.year}`}  
      </h1> 
      { dataSource.length 
        ?
          <>
            <DataGrid id="grid-container"
              dataSource={dataSource}
              keyExpr="ID"
              showBorders={true}
              {...presenter.getGridProps()} 
            >
              {presenter.summaryConfig ? 
                <Summary calculateCustomSummary={calculateTotalRow}>
                  {presenter.summaryConfig.map((sumConfig: any, index: number) => {
                    return <TotalItem key={index} {...sumConfig} />;
                  })}
                </Summary>
                : null}
              {dataColumns ? dataColumns.map((col: any)=>renderColumn(col)) : null}
              <MasterDetail
                enabled={true}
                render={renderDetail}
              />
            </DataGrid> 
            {!presenter._viewMode ? 
              <Button
                className={styles.detailButton}
                onClick={() => {
                  presenter.saveData(dataSource);
                }}
              >
                {presenter.currentLabels.get("Guardar")}
              </Button>
            : null}
          </>
        : 
          dataColumns ?
          <Container fluid={true}>
            <Alert color="warning">
              <h4 className={styles.alertWarning}>
                {presenter.currentLabels.get("NoResultadosBeneficiarios")}
              </h4>
            </Alert>
          </Container> 
          : null
      }
    </>
  )
}

export default CountryBeneficiaries;